/** @jsxImportSource theme-ui */

import React, { PropsWithChildren, useCallback } from 'react';
import { ThemeUIStyleObject } from 'theme-ui';

import { isKeyboardSelect } from 'utils/accessibilityHelpers';
import { focusStyles } from 'utils/cssHelpers';

import { IClickable } from 'components/_common/common-props';

const Styles: ThemeUIStyleObject = {
  outline: 'none',
  borderRadius: '2px',
  cursor: 'pointer',
  '&:focus': focusStyles(),
};

export const BdInteractiveSpan = React.forwardRef<HTMLSpanElement, PropsWithChildren<IClickable>>(
  ({ onClick, children, ...props }, ref) => {
    const onKeyPress = useCallback(
      (e: React.KeyboardEvent<HTMLAnchorElement>) => {
        if (isKeyboardSelect(e) && onClick) {
          e.preventDefault();
          onClick(e as any);
        }
      },
      [onClick]
    );

    return (
      <span
        ref={ref}
        tabIndex={0}
        onClick={onClick}
        onKeyPress={onKeyPress}
        role="button"
        className="interactive-span"
        sx={Styles}
        {...props}
      >
        {children}
      </span>
    );
  }
);
